<div class="rcd-root">

  @if (loading) {
    <div class="rcd-loading">Loading user connections…</div>
  }

  @if (!loading && error) {
    <div class="rcd-error">{{ error }}</div>
  }

  @if (!loading && !connectors.length) {
    <div class="rcd-empty">
      No Invoker connections found across the selected flows.
    </div>
  }

  @if (!loading && connectors.length) {
    <div class="rcd-intro">
      Pick a replacement user connection for each connector below. Every <b>Invoker</b>
      connection reference across the {{ rows.length }} selected flow{{ rows.length === 1 ? '' : 's' }}
      that binds to that connector will be rewritten to point at the chosen connection
      (and switched from <code>source: "Invoker"</code> to <code>source: "Embedded"</code>).
    </div>
  }

  @if (!loading && connectors.length) {
    <table class="rcd-table">
      <thead>
        <tr>
          <th>Connector</th>
          <th>Flows</th>
          <th>Replacement connection</th>
        </tr>
      </thead>
      <tbody>
        @for (c of connectors; track trackByApi($index, c)) {
          <tr>
            <td><code>{{ c.api }}</code></td>
            <td class="rcd-count">{{ c.flowCount }}</td>
            <td>
              @if (c.available.length) {
                <kendo-dropdownlist
                  [data]="c.available"
                  [textField]="'displayName'"
                  [valueField]="'name'"
                  [defaultItem]="{ displayName: '— leave unchanged —', name: '' }"
                  [(value)]="c.selected"
                  [valuePrimitive]="false"
                  [popupSettings]="{ width: 'auto' }"
                  style="width: 100%;">
                </kendo-dropdownlist>
              }
              @if (!c.available.length) {
                <span class="rcd-nocon">
                  No user connections for this connector in this environment.
                </span>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  }

  @if (!loading && (applying || hasResults())) {
    <div
      class="rcd-results">
      <div class="rcd-results-title">Per-flow result</div>
      <ul>
        @for (p of perFlow; track trackByFlow($index, p)) {
          <li
            [class.rcd-ok]="p.status === 'ok'"
            [class.rcd-err]="p.status === 'error'"
            [class.rcd-skip]="p.status === 'skipped'"
            [class.rcd-saving]="p.status === 'saving'">
            <span class="rcd-status">{{ p.status }}</span>
            <span class="rcd-flow">{{ p.displayName }}</span>
            @if (p.message) {
              <span class="rcd-msg">— {{ p.message }}</span>
            }
          </li>
        }
      </ul>
    </div>
  }

  <div class="rcd-actions">
    <button type="button" class="tb-btn-wide" (click)="cancel()" [disabled]="applying">Cancel</button>
    <button type="button" class="tb-btn-wide tb-btn-primary"
      (click)="apply()" [disabled]="!canApply()">
      {{ applying ? 'Applying…' : 'Apply' }}
    </button>
  </div>

</div>
